
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AppScoreSection',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('review', ['showDate', 'showScore'])
  }
};
